import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import languageEN from "./locales/en.json";
import languageDU from "./locales/du.json";
import languageFN from "./locales/fn.json";

export const lang =
  localStorage.getItem("lang") === "dutch"
    ? "nl"
    : localStorage.getItem("lang") === "french"
    ? "fr"
    : "en";

i18n
  .use(initReactI18next) // Initialize react-i18next
  .init({
    resources: {
      en: { translation: languageEN },
      fr: { translation: languageFN },
      nl: { translation: languageDU },
    },
    fallbackLng: lang,
    debug: true, // Logs helpful info during development
    backend: {
      loadPath: "/locales/{{lng}}/translation.json" // Path to translation files
    },
    interpolation: {
      escapeValue: false // React already handles XSS protection
    }
  });

export default i18n;
